export const StatusManager = (): null => null;
